<script setup lang="ts">
  import CollapsibleCard from '~/components/UI/Drawers/CollapsibleCard.vue';
  import type { ApproversList } from '~/types';

  const { items, creator, draftStatus } = defineProps<{
    creator: string;
    items: ApproversList;
    draftStatus: boolean;
    statusOf: string;
  }>();

  const approversList = computed(() => {
    return Object.entries(items).map(([key, value]) => {
      return {
        approver: key,
        approverDetails: value
      };
    });
  });
</script>

<template>
  <CollapsibleCard v-if="approversList?.length > 0" title="Approvals">
    <a-timeline>
      <div class="ml-[26px] mb-6">
        <p class="font-medium text-sm">{{ creator }}</p>
        <p class="text-xs font-medium" :class="draftStatus === true ? 'text-zinc-400' : 'text-green-700'">
          {{ draftStatus === true ? 'Not Submitted for Approval' : 'Submitted for Approval' }}
        </p>
      </div>
      <a-timeline-item v-for="value in approversList" :key="value.approver" class="flex flex-col p-0" color="gray">
        <div class="flex gap-1 justify-between items-center w-full">
          <p class="text-sm font-medium">
            {{ value?.approverDetails?.[`${statusOf}_approver_${value?.approver}`]?.split('-')?.pop() }}
          </p>
          <span class="text-xs font-medium text-zinc-400">#{{ value?.approver }}</span>
        </div>

        <div class="flex flex-col gap-1`">
          <p
            class="text-xs font-medium"
            :class="
              value?.approverDetails?.[`approver_status_${value?.approver}`] === 'Approved'
                ? 'text-green-700'
                : value?.approverDetails?.[`approver_status_${value?.approver}`] === 'Initiated'
                  ? 'text-orange-600'
                  : 'text-zinc-400'
            "
          >
            <!-- {{
              value?.approverDetails?.[`approver_status_${value?.approver}`] === 'Approved'
                ? 'Approved'
                : value?.approverDetails?.[`approver_status_${value?.approver}`] === 'Initiated'
                  ? 'Pending Approval'
                  : 'Queued for Approval'
            }} -->
            {{
              value?.approverDetails?.[`approver_status_${value?.approver}`] === 'Approved'
                ? value?.approverDetails?.[`approved_override_by_${value?.approver}`]
                  ? 'Approved (Control Admin Override)'
                  : 'Approved'
                : value?.approverDetails?.[`approver_status_${value?.approver}`] === 'Initiated'
                  ? 'Pending Approval'
                  : 'Queued for Approval'
            }}
          </p>
          <p v-if="value?.approverDetails?.[`approver_notes_${value?.approver}`]">
            {{ value?.approverDetails?.[`approver_notes_${value?.approver}`] }}
          </p>
        </div>

        <div
          v-if="value?.approverDetails?.[`approved_override_by_${value?.approver}`]"
          class="flex flex-col items-start text-xs font-medium py-2"
        >
          <span class="text-yellow-600">Approved by</span>
          <div class="flex flex-row gap-4 items-center">
            <div class="text-xs font-semibold">
              {{ value?.approverDetails?.[`approved_override_by_${value?.approver}`] }}
            </div>
            <span
              class="bg-purple-800 text-white px-2 py-[2px] flex justify-center items-center rounded text-[10px] font-semibold w-max"
            >
              {{
                value?.approverDetails?.[`approved_override_role_${value?.approver}`]?.replace('_', ' ')?.toUpperCase()
              }}
            </span>
          </div>
          <p
            v-if="value?.approverDetails?.[`approved_override_note_${value?.approver}`]"
            class="text-xs text-gray-600 pt-1"
          >
            {{ value?.approverDetails?.[`approved_override_note_${value?.approver}`] }}
          </p>
        </div>

        <div
          v-if="value?.approverDetails?.[`rejected_override_by_${value?.approver}`]"
          class="flex flex-col items-start text-xs font-medium py-2"
        >
          <span class="text-yellow-600">Rejected by</span>
          <div class="flex flex-row gap-4 items-center">
            <div class="text-xs font-semibold">
              {{ value?.approverDetails?.[`rejected_override_by_${value?.approver}`] }}
            </div>
            <span
              class="bg-purple-800 text-white px-2 py-[2px] flex justify-center items-center rounded text-[10px] font-semibold w-max"
            >
              {{
                value?.approverDetails?.[`rejected_override_role_${value?.approver}`]?.replace('_', ' ')?.toUpperCase()
              }}
            </span>
          </div>
          <p
            v-if="value?.approverDetails?.[`rejected_override_note_${value?.approver}`]"
            class="text-xs text-gray-600 pt-1"
          >
            {{ value?.approverDetails?.[`rejected_override_note_${value?.approver}`] }}
          </p>
        </div>
      </a-timeline-item>
    </a-timeline>
  </CollapsibleCard>
  <CollapsibleCard v-else title="Approvals">
    <a-empty description="No approvals!" />
  </CollapsibleCard>
</template>
